/** "Vidya D" -> "VD"; "Caissa_1200" -> "CA". Avatars are initials, not images. */
export const initialsOf = (name: string): string => {
  const parts = String(name || '')
    .trim()
    .split(/[\s_]+/)
    .filter(Boolean);
  if (parts.length === 0) {
    return '??';
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

/** "Rahul K" -> "Rahul" — the copy says "Rahul offers a draw". */
export const firstNameOf = (name: string): string =>
  String(name || 'Your opponent').split(/[\s_]+/)[0] || 'Your opponent';
